import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-covid19update',
  templateUrl: './covid19update.component.html',
  styleUrls: ['./covid19update.component.css']
})
export class Covid19updateComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
